import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIcon0108Lock({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M15.5 8H15V4.5C15 2.019 12.981 0 10.5 0h-1A4.505 4.505 0 005 4.5V8h-.5C3.673 8 3 8.673 3 9.5v9c0 .827.673 1.5 1.5 1.5h11c.827 0 1.5-.673 1.5-1.5v-9c0-.827-.673-1.5-1.5-1.5zM6 4.5C6 2.57 7.57 1 9.5 1h1C12.43 1 14 2.57 14 4.5V8H6V4.5zm10 14a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v9z" />
    </svg>
  );
}
export default SvgIcon0108Lock;
